import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datetime"
export default class extends Controller {
    static targets = ["display"]

    connect() {
        this.updateDateTime()
        // Met à jour la date/heure toutes les secondes
        this.timer = setInterval(() => {
            this.updateDateTime()
        }, 1000)

        // Écoute les changements de taille d'écran
        this.resizeHandler = () => {
            this.updateDateTime()
        }
        window.addEventListener('resize', this.resizeHandler)
    }

    disconnect() {
        // Nettoie le timer quand le contrôleur est déconnecté
        if (this.timer) {
            clearInterval(this.timer)
        }
        // Nettoie l'écouteur de redimensionnement
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler)
        }
    }

    updateDateTime() {
        const now = new Date()

        // Détecte si on est sur un petit écran
        const isSmallScreen = window.innerWidth < 992

        // Options pour le formatage de la date et de l'heure en français
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Europe/Paris'
        }

        // Ajoute le nom du jour seulement sur les grands écrans
        if (!isSmallScreen) {
            options.weekday = 'long'
        }

        // Formate la date en français
        const formattedDateTime = now.toLocaleDateString('fr-FR', options)

        // Met à jour l'élément d'affichage
        if (this.hasDisplayTarget) {
            this.displayTarget.textContent = formattedDateTime
        }
    }
}